
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.28 9.58A6.64 6.64 0 0019.65 3H10a1 1 0 00-1 .84L5.58 25.29a1 1 0 00.23.8 1 1 0 00.76.36h4.13l-.22 1.39a1 1 0 001 1.16h4.65a1 1 0 001-.83l1-6.11h3.15a7.46 7.46 0 007.43-7.45v-.28a5.87 5.87 0 00-2.43-4.75zM10.85 5h8.8a4.64 4.64 0 014.51 3.61 5.68 5.68 0 00-1.32-.15H14.5a1 1 0 00-1 .84l-.59 3.7a1 1 0 002 .32l.46-2.88h7.49a3.87 3.87 0 011.4.27 6.47 6.47 0 01-6.4 5.69h-4.64a1 1 0 00-1 .83L11 24.45H7.74zm15.86 9.61a5.46 5.46 0 01-5.43 5.45h-4a1 1 0 00-1 .83l-1 6.11h-2.64l.22-1.39 1.2-7.19h3.78A8.46 8.46 0 0026 12.1a3.82 3.82 0 01.71 2.23z","data-name":"paypal payment pay"}})])
          )
        }
      }
    